import { useQuery } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { UserDetailsIntegrations } from '@mint-sdk/api-integrations';

export const useUsersDetailsList = (usersIds: string[]) => {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isSuccess } = useQuery(
    {
      ...UserDetailsIntegrations.getUserDetails({
        urlParams: {
          userIds: usersIds.join(','),
        },
      }),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: usersIds.length > 0,
    },
    queryClient,
  );

  return {
    usersList: !usersIds.length ? [] : (data ?? []),
    isSuccess,
  };
};
